import { render } from "./NotificationModal.vue?vue&type=template&id=34bfb84f&scoped=true&ts=true"
import script from "./NotificationModal.vue?vue&type=script&lang=ts"
export * from "./NotificationModal.vue?vue&type=script&lang=ts"

import "./NotificationModal.vue?vue&type=style&index=0&id=34bfb84f&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bfb84f"]])

export default __exports__